import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { PieChartLoading } from '../../../../../../CommonComponents/OPL/charts/PieChart/PieChart.loading';
import { useIsCurrentPlanSelected } from '../../../../hooks/useIsCurrentPlanSelected';

export const SocialSecurityLoading = () => {
  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();
  return (
    <Box>
      <Box py="16">
        <Text fontWeight={500} fontSize="h5">
          Side by Side Comparison
        </Text>
      </Box>

      <HtmlTable variant="bordered">
        <table>
          <colgroup>
            <col width="20%" />
            <col width="16%" />
            <col width="16%" />
            <col width="16%" />
            <col width="16%" />
            <col width="16%" />
          </colgroup>

          <thead>
            <tr>
              <td> </td>
              {[100, 150, 140, 50, 80].map(size => (
                <td key={size}>
                  <Box
                    display="flex"
                    css={({ theme }) => ({ gap: theme.space['4'] })}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Shimmer width={size} height={24} />
                  </Box>
                </td>
              ))}
            </tr>

            <tr>
              <th colSpan={6}>
                <Text textAlign="left" fontWeight={600}>
                  Category
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <Shimmer width="100%" height={24} />
              </td>
              {[0, 1, 2, 3, 4].map(key => (
                <td key={key}>
                  <Box display="flex" justifyContent="center" width="100%">
                    <Box width="64px" height="64px">
                      <PieChartLoading />
                    </Box>
                  </Box>
                </td>
              ))}
            </tr>
            {[
              'Benefit Start Age',
              'First Year Benefit',
              'Total Lifetime Benefit',
              'Retirement Assets at End of Plan',
              'Net Worth at End of Plan',
              'Breakeven Age',
            ].map(label => (
              <tr key={label}>
                <td>
                  <Shimmer width="100%" height={24} />
                </td>
                {[0, 1, 2, 3, 4].map(key => (
                  <td key={key}>
                    <Shimmer width="100%" height={24} />
                  </td>
                ))}
              </tr>
            ))}
            {isCurrentPlanSelected && (
              <tr>
                <td />
                <td />
                {[0, 1, 2, 3].map(key => (
                  <td key={key}>
                    <Box display="flex" justifyContent="center" width="100%">
                      <Shimmer width={180} height={40} />
                    </Box>
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </HtmlTable>
    </Box>
  );
};
